(() => {
    const bar = document.querySelector('[data-refs-filter]');
    const wall = document.querySelector('[data-refs-list]');
    if (!bar || !wall) return;

    const cards = Array.from(wall.querySelectorAll('[data-ref]'));
    const sectorsOf = (card) => (card.getAttribute('data-sector') || '').split(' ').filter(Boolean);

    const present = new Set();
    cards.forEach((card) => sectorsOf(card).forEach((s) => present.add(s)));
    bar.querySelectorAll('[data-filter]').forEach((pill) => {
        const filter = pill.getAttribute('data-filter');
        if (filter !== 'all' && !present.has(filter)) {
            pill.remove();
        } else {
            pill.hidden = false;
        }
    });

    const applyFilter = (filter) => {
        cards.forEach((card) => {
            card.hidden = !(filter === 'all' || sectorsOf(card).indexOf(filter) !== -1);
        });
    };

    bar.querySelectorAll('[data-filter]').forEach((pill) => {
        pill.addEventListener('click', () => {
            bar.querySelectorAll('[data-filter]').forEach((p) => p.classList.remove('is-active'));
            pill.classList.add('is-active');
            applyFilter(pill.getAttribute('data-filter'));
        });
    });
})();
